<template lang="pug">
.tabela-registros-lote
    el-table(
        :data='registros',
        style='width: 100%'
    )
        el-table-column(
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.numero")',
            min-width='140'
        )
            template(slot-scope='scope') {{ scope.row.numeroCtg }}

        el-table-column(
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.corredor")',
            min-width='160'
        )
            template(slot-scope='scope') {{ scope.row.revenda }}

        el-table-column(
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.descricao")',
            min-width='200'
        )
            template(slot-scope='scope') {{ scope.row.descripcionMaterial }}

        el-table-column(
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.localidade")',
            min-width='160'
        )
            template(slot-scope='scope') {{ scope.row.oncca }}

        el-table-column(
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.cuit")',
            min-width='200'
        )
            template(slot-scope='scope') {{ formatarCuit(scope.row.cuit) }}

        el-table-column(
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.volumeToneladas")',
            min-width='200'
        )
            template(slot-scope='scope') {{ scope.row.cantidadEjecutar }}

        el-table-column(
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.status")',
            width='150'
        )
            template(slot-scope='scope')
                el-tag(
                    v-if='scope.row.status',
                    :type='corStatusRegistro(scope.row.status)',
                    size='mini',
                    effect='light'
                ) {{ rotuloStatusRegistro(scope.row.status) }}
                span(v-else) -

        el-table-column(
            :label='$t("mensagens.rastreabilidadeEmpresa.contratos.uploadTerritoriosProdutores.dataAnalise")',
            width='140'
        )
            template(slot-scope='scope') {{ scope.row.dataCadastro }}
</template>

<script>
import formatters from '@/utils/formatters';

const CORES_STATUS = {
    CONCLUIDO: 'success',
    DISCREPANCIA: 'danger'
};

export default {
    name: 'TabelaRegistrosLote',

    props: {
        registros: {
            type: Array,
            required: false,
            default: () => []
        }
    },

    methods: {
        formatarCuit(cuit) {
            return formatters.formatarCuit(cuit);
        },

        corStatusRegistro(status) {
            return CORES_STATUS[status] || 'info';
        },

        rotuloStatusRegistro(status) {
            const chave = `mensagens.rastreabilidadeEmpresa.contratos.historicoRecebimentos.statusRegistro.${status}`;
            const rotulo = this.$t(chave);

            return rotulo === chave ? status : rotulo;
        }
    }
};
</script>

<style lang="scss" scoped>
.tabela-registros-lote {
    padding: 8px 16px 16px;
    background: var(--white);

    &__paginador {
        display: flex;
        justify-content: flex-end;
        margin-top: 12px;
    }
}
</style>
